import Button from "@/components/button"
import Modal from "@/components/modal"

import { useState } from "react"

import nprogress from 'nprogress'
import axios from "axios"
import toast from "react-hot-toast"
import { useAuth } from "@/contexts/auth-context"
import { Trash } from "@/components/icons/outline"

const Content = ({ data, onSubmit }) => {
    // Contexts
    const { token } = useAuth()

    const handleSubmit = (e) => {
        e.preventDefault()

        nprogress.start()

        toast.loading("Loading", {
            id: "submit"
        })

        const url = `${process.env.REACT_APP_API_URL}/posts/${data.post.id}/reply/${data.reply.id}`

        axios.delete(url, { headers: { Authorization: `Bearer ${token}` } }).then((response) => {
            // Clear SWR cache
            // cache.clear()

            // Run on submit props
            onSubmit(data.reply.id)

            // Show toast message
            toast.success(response.data.message, {
                id: "submit"
            })
        }).catch((error) => {
            // Assign validation data
            // if (error.response.status === 400) {
            //     setErrors(error.response.data.errors)
            // }

            // Show toast message
            toast.error(error.response.data.message, {
                ariaProps: {
                    superscript: error.response.status
                },
                id: "submit"
            })
        })
    }

    return (
        <form onSubmit={handleSubmit} className="flex flex-col w-full space-y-6">
            Are You sure You want to delete this reply?
            <div className="flex items-center justify-between">
                <div></div>
                <Button type="submit">
                    <div className="text-sm font-semibold text-red-500">Delete</div>
                </Button>
            </div>
        </form>
    )
}

export default function DeleteReply({ data, onSubmit }) {
    const [isOpen, setIsOpen] = useState(false)

    const openModal = () => {
        setIsOpen(true)
    }

    const closeModal = () => {
        setIsOpen(false)
    }

    const handleSubmit = (value) => {
        closeModal()
        onSubmit(value)
    }

    return (
        <>
            <button onClick={() => openModal()}>
                <Trash className="text-red-500" />
            </button>
            <Modal title="Delete Reply" size="2xl" onClose={() => closeModal()} isOpen={isOpen} content={<Content data={data} onSubmit={handleSubmit} />} />
        </>
    )
}